<script lang="ts" setup>
const emits = defineEmits(["updateMerchant"]);

const props = defineProps<{
  itemNumber: number;
}>();

const appStateStore = useAppStateStore();
const merchant = ref<string>(appStateStore.currentMerchant);
const { trackEvent } = useGAnalytics();

const updateMerchant = (merchant: string) => {
  appStateStore.currentMerchant = merchant;
  emits("updateMerchant", merchant);
};
</script>

<template>
  <HeadlessListbox
    v-model="merchant"
    v-slot="{ open }"
    as="div"
    class="relative w-full sm:w-72">
    <HeadlessListboxButton
      class="w-full text-neutral-200 h-12 bg-neutral-800 border border-secondary-300 rounded-sm flex items-center justify-between p-2">
      <div class="flex items-center gap-2">
        <img
          :src="getGameIcon(merchant)"
          :alt="$t(`main.merchant.${merchant}`)"
          class="w-8 h-8"
          @click="trackEvent(`game_selector_${$route.path as string}`)" />
        <p class="text-neutral-300 font-bold truncate">
          {{ $t(`main.merchant.${merchant}`) }} ({{ itemNumber }})
        </p>
      </div>
      <BaseIconGrayArrow class="w-3" :rotate="open" :vertical="true" />
    </HeadlessListboxButton>
    <HeadlessListboxOptions
      class="w-full text-neutral-200 absolute top-[54px] left-0 z-10 truncate border border-secondary-400 rounded-sm bg-neutral-800">
      <HeadlessListboxOption
        v-for="activeMerchant in appStateStore.merchants.filter(
          (merchant) => merchant.status !== 'COMING_SOON'
        )"
        :key="activeMerchant.id"
        :value="activeMerchant.id">
        <div class="p-2">
          <div
            @click="updateMerchant(activeMerchant.id)"
            :id="activeMerchant.id"
            class="p-2 flex items-center gap-2 cursor-pointer text-neutral-300 hover:bg-neutral-500 hover:text-primary-500 rounded-sm"
            :class="{
              'bg-neutral-500': merchant === activeMerchant.id,
            }">
            <img
              :src="getGameIcon(activeMerchant.id)"
              :alt="$t(`main.merchant.${activeMerchant.id}`)"
              class="w-8 h-8" />
            <p class="font-bold truncate">
              {{ $t(`main.merchant.${activeMerchant.id}`) }}
            </p>
          </div>
        </div>
      </HeadlessListboxOption>
    </HeadlessListboxOptions>
  </HeadlessListbox>
</template>
